import React from "react";
import { Image } from "react-bootstrap";
import isEmpty from "../../../store/validation/is-Empty";
import SmallLoader from "../../Loader/SmallLoader";
import moment from "moment";
import {
  ORDER_TYPE,
  PAYMENT_STATUS,
  PAYMENT_TYPE,
  ORDER_STATUS,
  NEW_PAYMENT_TYPE,
} from "../../../enums/OrderEnums";
import { Toggle } from "../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import NoContent from "../../reusableComponents/NoContentComponent";

function TableHead(props) {
  return (
    <tr>
      <th style={{ width: "12%" }}>
        Order Type/
        <br /> Order ID
      </th>
      <th style={{ width: "12%" }}>Transaction ID</th>
      <th style={{ width: "12%" }}>User Name</th>
      <th style={{ width: "15%" }}>
        Payment Method/ <br />
        Payment Status
      </th>
      <th style={{ width: "10%" }}>
        No.of <br />
        Items
      </th>
      <th style={{ width: "10%" }}>Order Status</th>

      <th style={{ width: "10%" }}>Date & Time</th>

      <th style={{ width: "10%" }}>Amount</th>
      <th style={{ width: "6%" }}></th>
    </tr>
  );
}

export default TableHead;

export const TableBody = (props) => {
  // console.log(props?.paymentOrder[0]?.amount);
  const handleView = (data) => {
    props.handleView(data);
  };

  const displayAllTransactionId = (data) => {
    let transaction = data;
    let transactionArr = [];
    for (let i = 0; i < transaction.length; i++) {
      transactionArr.push(transaction[i].txnId);
    }
    return transactionArr;
  };

  return (
    <tbody
      className="w-100 super-admin-all-vendor-main-table-body"
      style={{ fontSize: "12px" }}
    >
      <tr className="w-100 p-0">
        <td className="p-0 w-100">
          <table className="w-100">
            <tbody className="sd_body_css">
              {props.auth.secondary_loader ? (
                <SmallLoader />
              ) : (
                !isEmpty(props.paymentOrder) ?
                props?.paymentOrder
                  .slice(props?.start, props?.end)
                  .map((item, index) => {
                    return (
                      <tr
                        className="sd_body_table-row"
                        // style={{ textAlign: "center" }}
                        key={index}
                      >
                        {/* {console.log(item.amount)} */}
                        <td
                          style={{
                            width: "12%",
                            paddingLeft: "1.75rem",
                          }}
                        >
                          <div className="f12-500">
                            {ORDER_TYPE[item?.orderId?.order_type]}
                            <br />
                            {item?.orderId?.order_id}
                          </div>
                        </td>
                        <td style={{ width: "12%" }}>
                          <div className="f12-500">
                            {item?.orderId?.splitPayment
                              ? displayAllTransactionId(
                                  item?.orderId?.transactionDetails
                                ).map((data, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      {data}
                                      <br />
                                    </React.Fragment>
                                  );
                                })
                              : item?.transactionNumber || item?._id}
                          </div>
                        </td>
                        <td style={{ width: "12%" }} className="text-center">
                          <div className="d-flex align-items-center">
                            <div className="super-admin-suggestion-imageBoxTwo ml-2">
                              <div className="f12-500">
                                {item?.user_id?.first_name}
                                {item?.user_id?.last_name}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td style={{ width: "15%" }}>
                          {/* <div className="f12-500">
                            {PAYMENT_TYPE[item?.orderId?.payment_method]}
                          </div> */}
                          <div className="f12-500">
                            {item?.orderId?.splitPayment ? (
                              <>Split Payment</>
                            ) : (
                              NEW_PAYMENT_TYPE[item?.orderId?.payment_method]
                            )}
                          </div>
                          {item?.orderId?.payment_status === 0 ? (
                            <div
                              className="badge badge-warning p-2"
                              style={{ borderRadius: "1rem", color: "white" }}
                            >
                              {PAYMENT_STATUS[item?.orderId?.payment_status]}
                            </div>
                          ) : null}
                          {item?.orderId?.payment_status === 1 ? (
                            <div
                              className="badge badge-success p-2"
                              style={{ borderRadius: "1rem", color: "white" }}
                            >
                              {PAYMENT_STATUS[item?.orderId?.payment_status]}
                            </div>
                          ) : null}
                          {item?.orderId?.payment_status === 2 ? (
                            <div
                              className="badge badge-danger p-2"
                              style={{ borderRadius: "1rem", color: "white" }}
                            >
                              {PAYMENT_STATUS[item?.orderId?.payment_status]}
                            </div>
                          ) : null}
                          {item?.orderId?.payment_status === 3 ? (
                            <div
                              className="badge badge-danger p-2"
                              style={{ borderRadius: "1rem", color: "white" }}
                            >
                              {PAYMENT_STATUS[item?.orderId?.payment_status]}
                            </div>
                          ) : null}
                          {item?.orderId?.payment_status === 4 ? (
                            <div
                              className="badge badge-info p-2"
                              style={{ borderRadius: "1rem", color: "white" }}
                            >
                              {PAYMENT_STATUS[item?.orderId?.payment_status]}
                            </div>
                          ) : null}
                        </td>

                        <td style={{ width: "10%" }}>
                          <div className="f12-500">
                            {item?.orderId?.order_items?.length}
                          </div>
                        </td>

                        <td style={{ width: "10%" }}>
                          <div className="f12-500">
                            {ORDER_STATUS[item?.orderId?.order_status]}
                          </div>
                        </td>
                        <td style={{ width: "10%" }}>
                          <div className="f12-400">
                            {moment(item?.createdAt).format("Do MMM YYYY")}
                          </div>
                          <div className="f12-400">
                            {moment(item?.createdAt).format("hh:mm A")}
                          </div>
                        </td>
                        <td style={{ width: "10%" }}>
                          <div className="f12-500">
                            ₹ {item?.orderId?.total_amount.toFixed(2)}
                          </div>
                        </td>
                        <td style={{ width: "6%" }}>
                          <div
                            className="f10-400 m-2"
                            align="center"
                            onClick={() => handleView(item.orderId)}
                          >
                            <img
                              src={require("../../../assets/images/iconButton/eye.png")}
                              width="35px"
                              alt="icon"
                            />
                          </div>
                        </td>
                      </tr>
                    );
                  }):<NoContent/>
              )}
            </tbody>
          </table>
        </td>
      </tr>
    </tbody>
  );
};
